export default "__VITE_PUBLIC_ASSET__6cbfd353__"